import { render, staticRenderFns } from "./TaSliderFeeling.vue?vue&type=template&id=1215e4d7&scoped=true&"
import script from "./TaSliderFeeling.vue?vue&type=script&lang=js&"
export * from "./TaSliderFeeling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1215e4d7",
  null
  
)

export default component.exports